<template>
    <v-row>
        <v-col>
            <div class="blacknew--text font-size-14 font-weight-500 mb-2">
                Rating Bulan {{ $moment().format("MMMM") }}
            </div>

            <v-card outlined color="#fcfcfd" class="border-solid-1">
                <v-card-text>
                    <div class="d-flex align-center gap-20">
                        <div class="text-center" style="line-height: 0.8em">
                            <div
                                class="blacknew--text mb-6 mt-4"
                                style="font-size: 50px; font-weight: 700"
                            >
                                {{ rating_month.average_rate }}
                            </div>
                            <div>
                                <v-rating
                                    :value="rating_month.average_rate"
                                    color="#ffcf3e"
                                    background-color="#f2f2f2"
                                    empty-icon="$ratingFull"
                                    half-increments
                                    small
                                    readonly
                                    style="margin-left: -10px"
                                ></v-rating>
                            </div>
                            <div class="blacknew--text font-size-14">
                                {{ rating_month.reviewer }} Konsul
                            </div>
                        </div>
                        <div class="pl-2" style="width: 80%">
                            <table width="100%">
                                <tr>
                                    <td width="20px" class="font-weight-600">
                                        5
                                    </td>
                                    <td>
                                        <v-progress-linear
                                            :value="
                                                rating_month
                                                    ? (rating_month.rate_detail
                                                          .rate_5 /
                                                          rating_month.reviewer) *
                                                      100
                                                    : 0
                                            "
                                            color="#2fca9e"
                                            background-color="#f2f2f2"
                                            rounded
                                            height="7"
                                        ></v-progress-linear>
                                    </td>
                                </tr>
                                <tr>
                                    <td class="font-weight-600">4</td>
                                    <td>
                                        <v-progress-linear
                                            :value="
                                                rating_month
                                                    ? (rating_month.rate_detail
                                                          .rate_4 /
                                                          rating_month.reviewer) *
                                                      100
                                                    : 0
                                            "
                                            color="#2fca9e"
                                            background-color="#f2f2f2"
                                            rounded
                                            height="7"
                                        ></v-progress-linear>
                                    </td>
                                </tr>
                                <tr>
                                    <td class="font-weight-600">3</td>
                                    <td>
                                        <v-progress-linear
                                            :value="
                                                rating_month
                                                    ? (rating_month.rate_detail
                                                          .rate_3 /
                                                          rating_month.reviewer) *
                                                      100
                                                    : 0
                                            "
                                            color="#2fca9e"
                                            background-color="#f2f2f2"
                                            rounded
                                            height="7"
                                        ></v-progress-linear>
                                    </td>
                                </tr>
                                <tr>
                                    <td class="font-weight-600">2</td>
                                    <td>
                                        <v-progress-linear
                                            :value="
                                                rating_month
                                                    ? (rating_month.rate_detail
                                                          .rate_2 /
                                                          rating_month.reviewer) *
                                                      100
                                                    : 0
                                            "
                                            color="#2fca9e"
                                            background-color="#f2f2f2"
                                            rounded
                                            height="7"
                                        ></v-progress-linear>
                                    </td>
                                </tr>
                                <tr>
                                    <td class="font-weight-600">1</td>
                                    <td>
                                        <v-progress-linear
                                            :value="
                                                rating_month
                                                    ? (rating_month.rate_detail
                                                          .rate_1 /
                                                          rating_month.reviewer) *
                                                      100
                                                    : 0
                                            "
                                            color="#2fca9e"
                                            background-color="#f2f2f2"
                                            rounded
                                            height="7"
                                        ></v-progress-linear>
                                    </td>
                                </tr>
                            </table>
                        </div>
                    </div>
                </v-card-text>
            </v-card>
        </v-col>

        <v-col>
            <div class="blacknew--text font-size-14 font-weight-500 mb-2">
                Rating Total
            </div>

            <v-card outlined color="#fcfcfd" class="border-solid-1">
                <v-card-text>
                    <div class="d-flex align-center gap-20">
                        <div class="text-center" style="line-height: 0.8em">
                            <div
                                class="blacknew--text mb-6 mt-4"
                                style="font-size: 50px; font-weight: 700"
                            >
                                {{ rating_all.average_rate }}
                            </div>
                            <div>
                                <v-rating
                                    :value="rating_all.average_rate"
                                    color="#ffcf3e"
                                    background-color="#f2f2f2"
                                    empty-icon="$ratingFull"
                                    half-increments
                                    small
                                    readonly
                                    style="margin-left: -10px"
                                ></v-rating>
                            </div>
                            <div class="blacknew--text font-size-14">
                                {{ rating_all.reviewer }} Konsul
                            </div>
                        </div>
                        <div class="pl-2" style="width: 80%">
                            <table width="100%">
                                <tr>
                                    <td width="20px" class="font-weight-600">
                                        5
                                    </td>
                                    <td>
                                        <v-progress-linear
                                            :value="
                                                rating_all
                                                    ? (rating_all.rate_detail
                                                          .rate_5 /
                                                          rating_all.reviewer) *
                                                      100
                                                    : 0
                                            "
                                            color="#2fca9e"
                                            background-color="#f2f2f2"
                                            rounded
                                            height="7"
                                        ></v-progress-linear>
                                    </td>
                                </tr>
                                <tr>
                                    <td class="font-weight-600">4</td>
                                    <td>
                                        <v-progress-linear
                                            :value="
                                                rating_all
                                                    ? (rating_all.rate_detail
                                                          .rate_4 /
                                                          rating_all.reviewer) *
                                                      100
                                                    : 0
                                            "
                                            color="#2fca9e"
                                            background-color="#f2f2f2"
                                            rounded
                                            height="7"
                                        ></v-progress-linear>
                                    </td>
                                </tr>
                                <tr>
                                    <td class="font-weight-600">3</td>
                                    <td>
                                        <v-progress-linear
                                            :value="
                                                rating_all
                                                    ? (rating_all.rate_detail
                                                          .rate_3 /
                                                          rating_all.reviewer) *
                                                      100
                                                    : 0
                                            "
                                            color="#2fca9e"
                                            background-color="#f2f2f2"
                                            rounded
                                            height="7"
                                        ></v-progress-linear>
                                    </td>
                                </tr>
                                <tr>
                                    <td class="font-weight-600">2</td>
                                    <td>
                                        <v-progress-linear
                                            :value="
                                                rating_all
                                                    ? (rating_all.rate_detail
                                                          .rate_2 /
                                                          rating_all.reviewer) *
                                                      100
                                                    : 0
                                            "
                                            color="#2fca9e"
                                            background-color="#f2f2f2"
                                            rounded
                                            height="7"
                                        ></v-progress-linear>
                                    </td>
                                </tr>
                                <tr>
                                    <td class="font-weight-600">1</td>
                                    <td>
                                        <v-progress-linear
                                            :value="
                                                rating_all
                                                    ? (rating_all.rate_detail
                                                          .rate_1 /
                                                          rating_all.reviewer) *
                                                      100
                                                    : 0
                                            "
                                            color="#2fca9e"
                                            background-color="#f2f2f2"
                                            rounded
                                            height="7"
                                        ></v-progress-linear>
                                    </td>
                                </tr>
                            </table>
                        </div>
                    </div>
                </v-card-text>
            </v-card>
        </v-col>
    </v-row>
</template>

<script>
import axios from "axios";

export default {
    name: "consul-history-rating",
    data() {
        return {
            loading: false,
            rating_all: {},
            rating_month: {},
        };
    },

    mounted() {
        this.getRatingAll();
        this.getRatingMonth();
    },

    methods: {
        getRatingAll() {
            const url = `${process.env.API_BASE_URL}konsul/admin/consul-rating/${this.$route.query.teacher_id}`;
            const authToken = JSON.parse(localStorage.getItem("token")).value;
            const options = {
                headers: {
                    Authorization: "Bearer " + authToken,
                },
            };

            const self = this;
            self.loading = true;

            axios
                .get(url, options)
                .then(function (response) {
                    self.rating_all = response.data;
                })
                .finally(() => {
                    self.loading = false;
                });
        },

        getRatingMonth() {
            const url = `${process.env.API_BASE_URL}konsul/admin/consul-rating-monthly/${this.$route.query.teacher_id}`;
            const authToken = JSON.parse(localStorage.getItem("token")).value;
            const options = {
                headers: {
                    Authorization: "Bearer " + authToken,
                },
            };

            const self = this;
            self.loading = true;

            axios
                .get(url, options)
                .then(function (response) {
                    self.rating_month = response.data;
                })
                .finally(() => {
                    self.loading = false;
                });
        },
    },
};
</script>

<style scoped>
.v-rating >>> .v-icon {
    margin-right: -15px !important;
    margin-top: -10px;
}
</style>



// WEBPACK FOOTER //
// ConsulHistoryRating.vue?2a7e9caa